import React, { useState } from 'react';
import { xhr } from '@shared/config';
import { tagsByModuleApi, useTags } from '@src/entities/common';

export const useLoadTags = (code?: string, needToLoad = true) => {
  const [isLoadingTags, setLoading] = useState(false);
  const { setTags } = useTags();

  const loadTags = () => {
    const load = async () => {
      try {
        setLoading(true);
        if (code) {
          const res = await xhr.get(tagsByModuleApi, {
            params: {
              code,
            },
          });
          setTags(res.data);
        }
        // resetSelectedTags();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    needToLoad && load();
  };

  React.useEffect(loadTags, [code]);

  return { isLoadingTags };
};
